/* eslint-disable max-len */
import { CQ_ACTION_CODES, CQ_POTS } from '../../../catalogConstants';
import { STRING_KEYS } from '../../common';
import { USER_TYPE } from '../../../bitConstants/constants';

export const localizedStrings = {
  common: {
    everyMainSelection: {
      [STRING_KEYS.process.title]: 'Añadir dispositivo',
      [STRING_KEYS.summary.title]: 'Añadir dispositivo',
      [STRING_KEYS.se.risk.subject]: 'TELCOBI - COMPRA TERMINAL PACK R2R - nuevo',
      [STRING_KEYS.se.order.subject]: 'TELCOBI - COMPRA TERMINAL PACK R2R',
      [STRING_KEYS.shipment.text]: 'Entrega en Madrid y Barcelona: 48h. Península: 72h. Excepto festivos..',
      [STRING_KEYS.shipment.secondaryText]: '',
      [STRING_KEYS.shipment.prePurchaseText]: 'Entrega en Madrid y Barcelona: 48h. Península: 72h. Excepto festivos. A partir de fin del periodo de reserva.',
      [STRING_KEYS.shipment.prePurchaseSecondaryText]: '',
      [STRING_KEYS.summary.shipment.text]: 'Entrega en Madrid y Barcelona: 48h. Península: 72h. Excepto festivos..',
      [STRING_KEYS.summary.shipment.secondaryText]: '',
      [STRING_KEYS.summary.shipment.prePurchaseText]: 'Entrega en Madrid y Barcelona: 48h. Península: 72h. Excepto festivos. A partir de fin del periodo de reserva.',
      [STRING_KEYS.summary.shipment.prePurchaseSecondaryText]: '',
      [STRING_KEYS.legalNSubmit.buttonText]: 'Ver y firmar contrato',
      [STRING_KEYS.legalNSubmit.prePurchaseButtonText]: 'Ver y firmar contrato',
      [STRING_KEYS.summary.cart.oneTimeChargesTitle[CQ_POTS.PAYMENT_POT.DIRECT_DEBIT_ID]]: 'Pago único en primera factura',
      [STRING_KEYS.summary.cart.oneTimeChargesFinalPriceText[CQ_POTS.PAYMENT_POT.DIRECT_DEBIT_ID]]: 'Pago único',
      [STRING_KEYS.summary.cart.pocDuration]: '{duration} cuotas',
      [STRING_KEYS.summary.cart.alwaysNew]: 'Cámbialo a los 24 meses',
      [STRING_KEYS.summary.cart.alwaysNewTemplate]: 'Cámbialo a los {months} meses',
      [STRING_KEYS.se.shippingMobileInsurance.subject]: 'TELCOBI - COMPRA SEGURO TERMINAL R2R SA',
      [STRING_KEYS.shoppingCart.prePurchaseTitle]: 'Resumen de la reserva',
      [STRING_KEYS.retargeting.id]: 'ret-r2r-cart',
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
  [`user_${USER_TYPE.TELCO}`]: {
    everyMainSelection: {
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
  [`user_${USER_TYPE.OPEN}`]: {
    everyMainSelection: {
    },
    [`mainSelection_${CQ_ACTION_CODES.REGISTER}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.PORTABILITY}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.MIGRATION}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.ACTIVATE_LINE}`]: {
    },
    [`mainSelection_${CQ_ACTION_CODES.UPGRADE_INCLUDED_LINE}`]: {
    },
  },
}
